module.exports = __webpack_public_path__ + "static/img/title.526b929.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/title.png
// module id = EJxl
// module chunks = 7